import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import { deleteForm, deleteForm2, sampleAsync } from '../../../redux/formsSlice';
import colors from "../formColors";

import leftJoinImage from '../../../assets/images/inner_join_left.png'
import rightJoinImage from '../../../assets/images/inner_join_right.png'
import innerJoinImage from '../../../assets/images/inner_join.png'
import { addJoinColumn, deleteJoinColumn, AddConditions } from '../../../redux/joinsSlice';
import getResearchData from '../../../api/getResearchData';
import { addColumn, resetColumns } from '../../../redux/columnsSlice';


const joinTypes = ["Left Join", "Right Join", "Inner Join"];

const joinImages = [leftJoinImage, rightJoinImage, innerJoinImage];


const FormsList = ({ setDeleteing }) => {
    const selectedProject = useSelector(state => state.selectedProject)
    const forms = useSelector((state) => state.forms)
    const joins = useSelector((state) => state.joins)
    // const [columns, setColumns] = useState([]);
    const columns = useSelector(state => state.columns);

    const divRef = useRef();

    const dispatch = useDispatch();

    const deleteFormClick = (index) => {
        setDeleteing(true)
        dispatch(deleteForm(index))
    }

    const baseWidth = 100 / forms.length;
    const extraHeight = joins.reduce((acc, cur) => acc + cur.count, 0) * 50;
    const paddingBottom = (30 + (joins.length * 125)) + extraHeight;

    const getResearch = (forms,index) => {
        if(index < forms.length){
            getResearchData(selectedProject.name, forms[index]).then((res) => {
                let initialization = Object.values(res.data.columnList);
                const initialObject = {};
                initialization.forEach((val) => initialObject[val] = true);
                dispatch(addColumn(initialObject))
                getResearch(forms, index + 1)
            });
        }
    }

    useEffect(() => {
        // setColumns([]);
        if(columns.length < forms.length){
            dispatch(resetColumns())
            getResearch(forms, 0)
        }
    }, [forms.length])

    const conditonalDataSet = () => {

    }

    const AddJoinsCondition = (index, joinIndex) => {
        dispatch(addJoinColumn(index));
        var addInnerConditionArray = [...joins[joinIndex].conditions];
        addInnerConditionArray.push([0,0]);
        dispatch(AddConditions({conditions: addInnerConditionArray, index: joinIndex}));
    }

    return (
        <div className="relative" ref={divRef}>
            <div className="flex">
                {forms.map((name, i) =>
                    <div
                        key={name + i}
                        className="px-3 pt-3 flex-1 flex flex-col"
                        style={{ background: `${colors[i % 4]}`, paddingBottom: paddingBottom + "px" }}
                        index={i}
                    >
                        <div className="flex items-center justify-between">
                            <p className="text-black font-bold text-lg m-0 my-auto">
                                {name}
                            </p>
                            <Button color="danger" size="sm" onClick={() => deleteFormClick(i)}>
                                <i className="ti-trash"></i>
                            </Button>
                        </div>
                    </div>)}
            </div>
            <div className="absolute bottom-0 left-0 w-full gap-10 flex flex-col mb-5">
                {joins.map(({ position, count }, i) => {
                    const [start, end] = position;
                    const length = Math.abs(start - end);
                    const calculatedWidth = baseWidth * (length + 1);
                    const reducedWidth = calculatedWidth - 16;
                    const left = 8 + start * baseWidth;
                    const firstSelections = columns[start] && Object.keys(columns[start]) || [];
                    const secondSelections = columns[end] && Object.keys(columns[end]) || [];
                    const joinIndex = end - 1;

                    return (
                        <div
                            key={i}
                            style={{ width: `${reducedWidth}%`, left: `${left}%` }}
                            className="relative p-2 bg-white rounded-md flex flex-col gap-3 justify-evenly"
                        >
                            <div className="flex justify-between items-center">
                                <ColumnSelection selections={joinTypes} inputClass="w-auto" isJoinType={true} />
                                <Button onClick={() => AddJoinsCondition(i, joinIndex)}>+ Ajouter conditions</Button>
                            </div>
                            <Join
                                firstSelections={firstSelections}
                                secondSelections={secondSelections}
                                firstLabel={forms[start]}
                                secondLabel={forms[end]}
                                index={i}
                                joinIndex={joinIndex}
                            />
                        </div>
                    )
                }
                )}
            </div>
        </div>
    )

    function getOptions(index) {
        return ["position", "age", "name"];
    }
}

function Join({ firstSelections, secondSelections, firstLabel, secondLabel, index, joinIndex }) {
    const count = useSelector(state => state.joins[index].count);
    const JoinConditions = useSelector((state) => state.joins);
    const dispatch = useDispatch();
    var countInc = 0;
    const deleteJoinCondition = (deleteJoin) => {
        dispatch(deleteJoinColumn(index));
        var conditionData2 = [...JoinConditions[joinIndex].conditions];
        conditionData2.splice(deleteJoin,1);
        dispatch(AddConditions({conditions: conditionData2, index: joinIndex}));
    }
    return <>
        {JoinConditions[joinIndex].conditions.map((data, joinIdx) => {
            var newcountInc = countInc;
            countInc++;
            return <div className="flex items-center">
                <ColumnSelection selections={firstSelections} label={firstLabel} index={newcountInc} type={0} joinIndex={joinIndex} selectedValue={data[0]} />
                <div className={countInc==1 ? "border border-gray-500 flex-1" : "border border-gray-500 flex-1 close-icon-center"} onClick={() => deleteJoinCondition(joinIdx)}></div>
                <ColumnSelection selections={secondSelections} label={secondLabel} index={newcountInc} type={1} joinIndex={joinIndex} selectedValue={data[1]} />
            </div>
        })
        }
    </>
}

function ColumnSelection({ selections, label, index, type, joinIndex, selectedValue, inputClass, isJoinType }) {
    const [selected, setSelected] = useState(0);
    const alljoins = useSelector((state) => state.joins);
    const dispatch = useDispatch();
    const changeSelected = (e) => {
        setSelected(e.target.value);
        var conditionData = alljoins[joinIndex];
        var conditionData2 = [...alljoins[joinIndex].conditions];
        var nextconditionData = [...conditionData.conditions[index]];
        nextconditionData[type] = Number(e.target.value);
        conditionData2[index] = nextconditionData;
        dispatch(AddConditions({conditions: conditionData2, index: joinIndex}));
    }    

    if (!selections) return <></>;
    return <FormGroup className="flex m-0 items-center px-2 gap-1">
        {isJoinType && <Label className="whitespace-nowrap m-0" for="exampleSelect">
            {isJoinType ? <img className="w-16" src={joinImages[selected]} alt="join" /> : label}
        </Label>}

        <Input onChange={changeSelected} value={selectedValue} className={`m-0 ${inputClass}`} type="select" name="select">
            {
                selections && selections.map((val, i) => <option value={i}>{val}</option>)
            }
        </Input>
    </FormGroup>
}

export default FormsList
